var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49996 13.4742L4.60829 10.5825C4.45248 10.4267 4.24115 10.3392 4.02079 10.3392C3.80044 10.3392 3.58911 10.4267 3.43329 10.5825C3.27748 10.7384 3.18994 10.9497 3.18994 11.17C3.18994 11.2792 3.21143 11.3872 3.25319 11.488C3.29494 11.5888 3.35614 11.6804 3.43329 11.7575L6.91663 15.2409C7.24163 15.5659 7.76663 15.5659 8.09163 15.2409L16.9083 6.42421C17.0641 6.2684 17.1516 6.05707 17.1516 5.83671C17.1516 5.61635 17.0641 5.40502 16.9083 5.24921C16.7525 5.0934 16.5411 5.00586 16.3208 5.00586C16.1004 5.00586 15.8891 5.0934 15.7333 5.24921L7.49996 13.4742Z",
    fill: "#0B7CDA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e0681222c43e1303373d4adf39824241.svg";
export { ForwardRef as ReactComponent };